import * as React from "react";

/**
 * Tailwind's breakpoints as media queries, for the rare case where a layout has
 * to switch component trees in JS instead of with `md:` / `lg:` classes —
 * rendering both trees and hiding one with CSS would mount the hidden one too.
 */
export const screen = {
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
} as const;

/** Subscribes to a CSS media query and re-renders when it starts/stops matching. */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(
    () => window.matchMedia(query).matches
  );

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    // The query may have changed between render and effect.
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
